export enum SignOutMessage {
  SessionExpired = 'session-expired',
}
